module.exports = __webpack_public_path__ + "img/subject_banner13.1acaf895.png";